// extracted by mini-css-extract-plugin
export default {"quizContainer":"quizContainer__W58Zg","quizImage":"quizImage__GD49P","quizContent":"quizContent__p+g6X"};